export const NOTICE_PALETTES = {
  navy: {
    header: 'rgb(30, 64, 95)',
    headerText: '#ffffff',
    wash: '#eef1f4',
    accent: 'rgb(30, 64, 95)',
    accentSoft: '#d5dce3'
  },
  green: {
    header: 'linear-gradient(135deg, rgb(100, 190, 130), rgb(60, 180, 120))',
    headerText: '#ffffff',
    wash: 'rgb(245, 250, 246)',
    accent: 'rgb(60, 180, 120)',
    accentSoft: 'rgb(200, 230, 210)'
  },
  purple: {
    header: '#4f46e5',
    headerText: '#ffffff',
    wash: '#eef2ff',
    accent: '#4f46e5',
    accentSoft: '#e0e7ff'
  },
  teal: {
    header: '#0f766e',
    headerText: '#ffffff',
    wash: '#f0fdfa',
    accent: '#0d9488',
    accentSoft: '#ccfbf1'
  },
  blue: {
    header: 'rgb(30, 64, 95)',
    headerText: '#ffffff',
    wash: '#eef1f4',
    accent: 'rgb(30, 64, 95)',
    accentSoft: '#d5dce3'
  }
};

export const DEFAULT_NOTICE_PALETTE = NOTICE_PALETTES.green;

export const resolveNoticePalette = (notice) => {
  const value = notice?.palette;
  if (!value) {
    return DEFAULT_NOTICE_PALETTE;
  }
  if (typeof value === 'string') {
    return NOTICE_PALETTES[value] || DEFAULT_NOTICE_PALETTE;
  }

  const base = NOTICE_PALETTES[value.preset] || DEFAULT_NOTICE_PALETTE;
  const { preset, ...overrides } = value;
  return { ...base, ...overrides };
};

export const paletteCssVars = (palette) => ({
  '--nb-header': palette.header,
  '--nb-header-text': palette.headerText,
  '--nb-wash': palette.wash,
  '--nb-accent': palette.accent,
  '--nb-accent-soft': palette.accentSoft
});
